const Layout = ({children} : {children: any}) => {

  return (
    <>
      <div className="ramadhan-section">
        {children}
      </div>
    </>
  )
}

export default Layout